// views
import SiteLayout from "~/components/layout/SiteLayout";
import { Card } from "antd";

export default (props) => {
  return (
    <SiteLayout pageTitle="隐私政策">
      <Card>
        <h1 className="page-title">隐私政策</h1>
        <p>
          更新日期：2024年7月2日 <br />
          生效日期：2024年7月2日
        </p>
        <p class="p1">
          西安总而言之网络科技有限公司（以下简称「电鸭App」或「我们」）非常重视您的个人信息，并让您对个人信息拥有控制权，我们会使用强大的加密技术来保护您的隐私，同时制定严格的政策来管理所有数据。当您访问
          电鸭App时，或使用我们提供的服务前，您需要同意本政策中关于我们如何收集、使用、储存和分享您的相关信息的规定。如果您不同意本隐私政策中的任何内容，请立即停止使用或访问我们的产品和服务。若您对本政策有任何问题，请发邮件至
          eleduck@qq.com与我们联系
        </p>
        <p class="p2">
          <strong>本隐私政策要点如下：</strong>
        </p>
        <p class="p1">
          i.
          我们将逐一说明我们收集的您的个人信息类型及其对应的用途，以便您了解我们针对某一特定功能所收集的具体个人信息的类别、使用理由及收集方式。ii.
          当您使用一些功能时，我们会在获得您的同意后，收集您的一些敏感信息，除非按照相关法律法规要求必须收集，拒绝提供这些信息仅会使您无法使用相关特定功能，但不影响您正常使用「电鸭
          App」的其他功能。iii. 目前，「电鸭
          App」不会主动共享或转让您的个人信息至「电鸭
          App」外的第三方，如存在其他共享或转让您的个人信息或您需要我们将您的个人信息共享或转让至「电鸭
          App」外的第三方情形时，我们会直接或确认第三方征得您对上述行为的明示同意，此外，我们会对对外提供信息的行为进行风险评估。iv.
          目前，「电鸭 App」不会主动从「电鸭
          App」外的第三方获取您的个人信息。如未来为业务发展需要从第三方间接获取您的个人信息，我们会在获取前向您明示您个人信息的来源、类型及使用范围，如「电鸭
          App」开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您的该等个人信息前，征得您的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。v.
          您可以通过本指引所列途径访问、更正、删除您的个人信息，也可以撤回同意、注销帐号、投诉举报以及设置隐私功能。
        </p>
        <p class="p2">
          <strong>
            如您想了解更加详尽的信息，请根据以下索引阅读相应章节：
          </strong>
        </p>
        <p class="p1">
          一、我们如何搜集和使用您的信息二、我们如何使用 Cookie
          和同类技术三、如何更新、变更、导出、删除您的信息四、我们如何保护您的个人信息五、我们如何处理未成年人提供的个人信息六、我们如何共享、转让、公开披露您的个人信息七、信息的存储八、第三方服务提供商九、本政策的更新十、适用范围十一、如何联系我们
        </p>
        <p class="p2">
          <strong>一、我们如何搜集和使用您的信息？</strong>
        </p>
        <p class="p3">
          <strong>1、我们如何搜集您的信息？</strong>
        </p>
        <p class="p1">我们提供服务时，可能会收集、储存和使用下列信息：</p>
        <p class="p1">
          <strong>1.1 您提供的信息</strong>
        </p>
        <p class="p4">
          <strong>
            1.1.1
            您在注册账户或使用我们的服务时，向我们提供的可用于识别用户的个人身份的信息，例如姓名、联系方式、工作职位等信息，或我们可以正当地通过链接找到此类信息的其他数据。如果您想充分使用我们提供的各种分享功能，可能还需要创建公开显示的个人资料，其中可能会包含您的姓名和工作职位。
          </strong>
        </p>
        <p class="p4">
          <strong>
            1.1.2
            您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时上传、提交、存储、发送或接收的信息。
          </strong>
        </p>
        <p class="p1">
          <strong>1.2 您在使用服务过程中，我们获取的信息</strong>
        </p>
        <p class="p1">
          我们会收集您使用的服务以及使用方式的信息，如您使用「电鸭
          App」发表帖子、评论、申请工作等服务时可能产生的相关信息。此类信息包括：
        </p>
        <p class="p4">
          <strong>1.2.1 设备信息：</strong>
        </p>
        <p class="p1">
          我们会根据您在软件安装及/或使用授权的具体权限，接收并记录您所使用的设备相关信息，例如您的设备型号、操作系统版本信息、设备设置、移动设备版本、设备识别码、屏幕分表率、设备环境等软硬件特征信息、设备所在位置相关信息，例如IP地址、GPS位置以及能够提供相关信息的WLAN接入点、蓝牙和基站等传感器信息。如果您在安装及/或使用过程中拒绝授予我们相应权限的，我们并不会记录您上述对应的信息。
        </p>
        <p class="p4">
          <strong>1.2.2 日志信息</strong>
        </p>
        <p class="p1">
          A.
          设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；B.
          在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面URL地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；
        </p>
        <p class="p4">
          <strong>1.2.3 IP地址</strong>
        </p>
        <p class="p1">
          A.
          有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；B.
          您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；C.
          您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。
        </p>
        <p class="p4">
          <strong>1.2.4 设备中的视频、图片、游戏软件等</strong>
        </p>
        <p class="p1">
          为了给您提供全方位的体验，经过您的授权，我们的客户端会将您主动上传的视频、图片加密上传到服务器进行存储；可能会提取您设备中的软件名、版本号，通过加密上传到服务器进行处理、存储。同时，您也可以随时通过相关功能设置拒绝/取消该权限。拒绝提供该权限仅会使您无法使用上述功能，但不影响「电鸭App
          <span class="s1">」</span>
          其他功能与服务的正常使用；但当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的信息，否则您的取消行为不会影响我们基于您之前的授权进行的信息的存储或处理。
        </p>
        <p class="p4">
          <strong>1.2.5 拍摄照片</strong>
        </p>
        <p class="p1">
          当您使用拍摄照片功能时，我们将访问您的设备相机相关权限，并收集您提供的拍摄的照片视频后向我们上传的图片、视频信息。如您拒绝提供权限和内容的，仅会使您无法使用该功能，但并不影响您正常使用「电鸭App」的其他功能。同时，您也可以随时通过相关功能设置取消该权限。当您取消该授权后，我们将不再收集该信息，也无法再为您提供上述与之对应的服务；但除非您依照法律的规定删除了您的信息，否则您的取消行为不会影响我们基于您之前的授权进行的信息的处理、存储。
        </p>
        <p class="p4">
          <strong>1.2.6 交易信息</strong>
        </p>
        <p class="p1">
          您可以在「电鸭
          App」内购买商品/服务（如：电量）。在您使用该功能的过程中可能会需要进行支付，在支付过程中，我们可能会收集您的第三方支付账号。
        </p>
        <p class="p4">
          <strong>1.2.7 来源于第三方的信息</strong>
        </p>
        <p class="p1">
          在一些法律允许的情况下，我们可能从第三方处获得您的个人信息。例如：出于安全和防欺诈的目的，针对特定账号、金融交易等服务，在您授权的前提下，通过合法来源核实您的信息（如电话号码）；；我们还可能从第三方社交网络服务中获取某些信息，例如账户、昵称（例如，当您使用社交网络账户登录「电鸭App」服务时）；
        </p>
        <p class="p4">
          <strong>1.2.8 非个人信息</strong>
        </p>
        <p class="p1">
          我们还可能收集其他无法识别到特定个人、根据当地适用法律不属于个人信息的信息，例如您使用特定服务时产生的统计类数据，如匿名设备相关信息、日活事件、页面访问事件、页面访问时长事件、会话事件；网络监控数据如请求时长、请求与错误请求数等；以及应用崩溃事件。收集此类信息的目的在于改善我们向您提供的服务。所收集信息的类别和数量取决于您如何使用我们产品或服务。我们会收集诸如唯一设备标识符、设备型号、系统版本号等与您在我们的网站或移动应用中的活动有关的信息。我们会将此类信息汇总，用于帮助我们向客户提供更有用的信息，了解客户对我们网站、产品或服务中的哪些部分最感兴趣。就本隐私政策而言，汇总数据被视为非个人信息。如果我们将非个人信息与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。
        </p>
        <p class="p4">
          <strong>1.2.9 后台运行</strong>
        </p>
        <p class="p1">
          「电鸭
          App」在后台运行时，会收集您的设备标识信息（MAC地址、DEVICE_id、IMEI、设备序列号）和日志信息，用于信息推送、安全风控。如您拒绝，不影响您使用「电鸭
          App」
        </p>
        <p class="p3">
          <strong>2、我们如何使用您的信息</strong>
        </p>
        <p class="p1">
          收集个人信息的目的在于向您提供产品或服务，并且保证我们遵守适用的相关法律、法规及其他规范性文件。我们可能将上述收集的信息用作以下用途：
        </p>
        <p class="p1">
          <strong>
            2.1 向您提供、处理、维护、改善、开发我们的产品或提供给您的服务，
            例如交付、验证、售后、客户支持；
          </strong>
        </p>
        <p class="p1">
          <strong>
            2.2
            在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；
          </strong>
        </p>
        <p class="p1">
          <strong>
            2.3
            内部目的，如数据分析、研究和开发与我们产品或服务的使用相关的统计信息，以更好地改进我们的产品或服务；
          </strong>
        </p>
        <p class="p1">
          <strong>2.4 帮助我们设计新服务，改善我们现有服务；</strong>
        </p>
        <p class="p1">
          <strong>2.5 执行软件验证、升级服务；</strong>
        </p>
        <p class="p1">
          <strong>
            2.6
            应用户特殊要求而提供特定服务时，需要将信息提供给我们的关联公司、第三方或其他用户；
          </strong>
        </p>
        <p class="p1">
          <strong>2.7 其他不违反任何强制性法律法规的情况；</strong>
        </p>
        <p class="p1">
          <strong>2.8 让您参与有关我们产品和服务的调查；</strong>
        </p>
        <p class="p1">
          <strong>
            2.9 储存并维护与您相关的信息，用于我们的业务运营
            （例如业务统计）或履行法律义务；
          </strong>
        </p>
        <p class="p1">
          <strong>2.10 其他征得您同意的目的。</strong>
        </p>
        <p class="p1">
          <strong>
            关于我们如何使用您的信息（其中可能包含个人信息），下面提供了更多详细示例：
          </strong>
        </p>
        <p class="p1">
          ● 登录使用「电鸭 App」产品或服务；
          <br />
          ● 创建及维护您的「电鸭App」账号。
          您通过网站或移动设备创建「电鸭App」账号时提供的个人信息可用于建立您个人「电鸭
          App」账号和个人资料；
          <br />●
          参与社区。「电鸭App」或其他类似社交平台有关的个人信息可能被用于个人资料页面展示、与其他用户进行互动等；
          <br />● 改善用户体验。
          某些选择性加入功能，例如用户体验计划，允许我们分析用户如何使用手机和「电鸭App」服务的数据，以改善用户体验，例如发送崩溃报告；
          <br />● 提供推送服务。「电鸭
          App」账号和IMEI/GAID编号可能用于提供「电鸭
          App」的推送服务，向您发送软件更新或新产品发布的通知。同时，在第三方（同样为您个人信息的数据控制者
          - 更多详细信息请参阅下方&ldquo;
          我们如何共享，转移和公开披露您的个人信息&rdquo;）的授权下，「电鸭
          App」的推送服务也将使用您的「电鸭 App」账号和IMEI/GAID编号，从「电鸭
          App」向您发送相关通知。
          我们可能基于推送服务（无论是通过服务中集成的信息推送或其他方式）而使用您个人信息，并为您提供我们及相关第三方的产品或服务。
          您可以随时通过更改手机设置项下的偏好设置来拒绝接收来自我们及第三方的信息，或通过使用「电鸭
          App」“我的-设置-推送设置”设置是否接受我们通过“通知”给您的信息。
          <br />● 收集用户反馈。 您选择提供的反馈对帮助「电鸭
          App」改进服务非常重要。为了处理您提供的反馈，「电鸭
          App」可能会使用您所提供的个人信息与您联系，并保留记录用于解决问题及改进服务；
          <br />● 发送通知。
          我们可能会将您的个人信息用于发送重要通知，例如有关帖子的通知和我们的条款、条件和政策的变更。由于此类信息对您和我们之间的沟通至关重要，不建议您拒绝接收此类信息；我们可能将这些信息与其他信息结合起来（包括跨不同服务或设备如电脑、手机、智能硬件和其他联网设备中的信息），用于提供和改进我们的产品、服务、内容。例如，我们可能会在所有需要「电鸭
          App」账号的服务中使用您「电鸭
          App」账号的详细信息。同时，为了让您有更好的体验以及改善我们的服务，在符合相关法律法规规定或经您同意时，我们可能会将来自您或与您相关的不同产品、服务或设备的信息整理成标签，来提供建议和定制内容功能。根据我们合并信息的原因以及适用法律的要求，我们将为您提供此类整合的具体控制机制。您有权拒绝以直接营销目的进行的个人信息处理以及自动化决策等。
        </p>
        <p class="p3">
          <strong>3、我们承诺</strong>
        </p>
        <p class="p1">
          <strong>
            3.1
            在任何时候、任何情况下都不会向任何第三方出售您的个人信息，我们只会在法律允许的范围内使用根据本协议获得的信息。我们会制定严格的政策保护您的个人信息，除非事先获得您的授权或本声明另有规定之外，不会将您的这些信息对外公开或向第三方提供。
          </strong>
        </p>
        <p class="p1">
          另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：
        </p>
        <p class="p1">
          <strong>
            4.1
            与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；
          </strong>
        </p>
        <p class="p1">
          <strong>4.2 与犯罪侦查、起诉、审判和判决执行等直接相关的；</strong>
        </p>
        <p class="p1">
          <strong>
            4.3
            出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
          </strong>
        </p>
        <p class="p1">
          <strong>4.4 所收集的个人信息是您自行向社会公众公开的；</strong>
        </p>
        <p class="p1">
          <strong>
            4.5
            从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
          </strong>
        </p>
        <p class="p1">
          <strong>4.6 根据您要求签订和履行合同所必需的；</strong>
        </p>
        <p class="p1">
          <strong>
            4.7
            用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
          </strong>
        </p>
        <p class="p1">
          <strong>4.8 为开展合法的新闻报道所必需的；</strong>
        </p>
        <p class="p1">
          <strong>
            4.9
            出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
          </strong>
        </p>
        <p class="p1">
          <strong>4.10 为完成合并、分立、收购或资产转让而转移；</strong>
        </p>
        <p class="p1">
          <strong>4.11 法律法规规定的其他情形。</strong>
        </p>
        <p class="p1">
          请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。请您注意，目前「电鸭
          App」不会主动从「电鸭
          App」外的第三方获取您的个人信息。如未来为业务发展需要从第三方间接获取您个人信息，我们会在获取前向您明示您个人信息的来源、类型及使用范围，如「电鸭
          App」开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您的该等个人信息前，征得您的明示同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。
        </p>
        <p class="p3">
          <strong>
            5、除非经过您的同意，否则我们不会向任何人提供您的敏感个人信息。
          </strong>
        </p>
        <p class="p3">
          <strong>6、个人信息的匿名化处理</strong>
        </p>
        <p class="p1">
          在收集到您的个人信息后，我们将通过技术手段及时对数据进行匿名化处理。在不泄露您个人信息的前提下，「电鸭
          App」有权对匿名化处理后的用户数据库进行挖掘、分析和利用（包括商业性使用），有权对产品/服务使用情况进行统计并与公众/第三方共享脱敏的统计信息。
        </p>
        <p class="p2">
          <strong>二、我们如何使用 Cookie 和同类技术</strong>
        </p>
        <p class="p1">
          Cookie
          是包含字符串的小文件，会在您访问网站时发送到您的计算机上。当您再次访问网站时，Cookie
          使该网站可以识别您的浏览器。Cookie
          还能存储用户使用偏好及其他信息。您可以重置您的浏览器拒绝所有的Cookie
          ，或者在发送 Cookie 时提示。但如果没有 Cookie
          ，某些网站功能或服务可能无法正常工作。Cookie
          和同类型技术是互联网中的通用常用技术。当您使用「电鸭App」相关服务时，我们可能会使用相关技术向您的设备发送一个或多个
          Cookie
          或匿名标识符，以收集和存储您访问、使用「电鸭App」时的信息。我们将通过Cookie和其他技术收集的信息视为非个人信息。但是，如果当地法律将互联网协议
          (IP)
          地址或类似识别标记视为个人信息，我们亦将此等识别标记视为个人信息。我们使用
          Cookie 和同类技术主要为了实现以下功能或服务：
        </p>
        <p class="p3">
          <strong>1、保障产品与服务的安全、高效运转</strong>
        </p>
        <p class="p1">
          我们可能会设置认证与保障安全性的 Cookie
          或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈等不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。
        </p>
        <p class="p3">
          <strong>2、帮助您获得更轻松的访问体验</strong>
        </p>
        <p class="p1">
          使用此类技术可以帮助您省去重复填写个人信息、输入搜索内容的步骤和流程，例如实现一键登录流程、记录搜索历史。
        </p>
        <p class="p3">
          <strong>3、日志文件</strong>
        </p>
        <p class="p1">
          和大部分网站一样，我们收集特定信息并保存在日志文件中。此类信息可能包括互联网协议
          (IP) 地址、浏览器类型、互联网服务供应商
          (ISP)、引用/退出页面、操作系统、日期/时间戳和/或点击流数据。我们不会把自动收集的日志数据与我们收集的其他信息进行关联。
        </p>
        <p class="p3">
          <strong>4、移动分析</strong>
        </p>
        <p class="p1">
          在某些移动应用中，我们使用移动分析软件，以更好地了解我们的移动软件在您的手机中的功能。此款软件可能记录以下信息，如您使用该应用程序的频率、该应用程序内发生的事件、累计使用、性能数据及应用程序崩溃发生的位置。我们不会将存储于分析软件内的信息与您在移动应用程序中提交的任何个人信息相关联。
        </p>
        <p class="p3">
          <strong>5、本地存储- HTML5/Flash</strong>
        </p>
        <p class="p1">
          我们使用本地存储对象
          (LSO)，例如HTML5或Flash，来存储内容。与我们合作在「电鸭
          App」上提供某些功能，也会通过HTML5或Flash
          Cookie来收集和存储相关信息。各种浏览器提供了各自的管理工具来删除HTML5本地存储对象。
        </p>
        <p class="p2">
          <strong>三、如何查询、更新、变更、导出、删除您的信息</strong>
        </p>
        <p class="p1">依据某些司法管辖区的法律规定：</p>
        <p class="p3">
          <strong>
            1、您在使用我们的产品和服务时，会被要求提供您真实的个人信息，您应当对您所提供信息的真实性、合法性、有效性及完整性负责，并及时更新和维护您的个人信息，以保证信息的真实、合法和有效。您可以随时管理您的个人信息，例如您的个人账户注册信息。
          </strong>
        </p>
        <p class="p3">
          <strong>
            2、我们通过交互界面的设计，为您提供了可自行访问、查询、更正相关个人信息的渠道，您可通过以下方式进行设置：
          </strong>
        </p>
        <p class="p1">
          <strong>
            2.2.1
            您可以通过「我的」-「个人资料」进行访问、更正自己的个人资料，含头像、昵称、性别、生日、所在城市、简介；
          </strong>
        </p>
        <p class="p1">
          <strong>
            2.2.2 您可以通过「我的」-
            「设置」-「账号安全」设置、访问、更正账号信息，含手机号、绑定的第三方平台账号（含微信、Apple
            ID、手机号码等）；
          </strong>
        </p>
        <p class="p3">
          <strong>
            3、您可以自行从「电鸭」账号中删除您的内容或个人信息，或要求我们删除或修改信息，例如您想要删除个人帐户，可以发送邮件到
            eleduck@qq.com与我们联络并提出您的要求。
          </strong>
        </p>
        <p class="p3">
          <strong>
            4、在有些情况下，我们会出于法律目的或合法业务的需要将数据保留有限的一段时间。我们会尽力确保
            「电鸭」的服务能够保护信息免遭意外或恶意删除。因此，如果您删除了某些内容，我们可能会在15个工作日内从我们现用的和备用的系统中删除其副本。
          </strong>
        </p>
        <p class="p3">
          <strong>
            5、您可以随时备份个人帐户名下的内容或将其用于非 「电鸭」
            服务，您可以发邮件到eleduck@qq.com与我们联络并提出您的要求。
          </strong>
        </p>
        <p class="p3">
          <strong>6、撤销同意</strong>
        </p>
        <p class="p1">
          您可以通过提交请求撤销之前出于特定目的授予我们的同意，包括收集、使用和/或披露我们掌握或控制的您的个人信息。根据您所使用的具体服务，您可以通过发送邮件至eleduck@qq.com进行反馈。我们将会在您做出请求后的合理时间内处理您的请求，并且会根据您的请求，此后不再收集、使用和/或披露您的个人信息。取决于您撤销同意的范围，其可能导致您不能继续享受「电鸭
          App」的产品或服务。但您撤回同意或授权的决定，不会影响我们此前基于您的同意而开展的个人信息处理活动的有效性。
        </p>
        <p class="p3">
          <strong>7、注销账号</strong>
        </p>
        <p class="p1">
          您可以通过「电鸭 App」“我的-设置-帐号安全-帐号注销”
          申请注销您的帐号（即时生效）。您注销账号后，我们将停止为您提供产品与服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。
          当您通过第三方账号授权登录「电鸭App」时，需要向第三方申请注销账号。
        </p>
        <p class="p2">
          <strong>四、我们如何保护您的个人信息</strong>
        </p>
        <p class="p3">
          <strong>
            1、我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。我们使用多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括技术保护手段、管理制度控制、安全体系保障等诸多方面。
          </strong>
        </p>
        <p class="p3">
          <strong>
            2、为了保护您的个人信息安全，我们将努力采取各种符合行业标准的安全措施来保护您的个人信息以最大程度降低您的个人信息被丢失、毁损、盗用、泄露、非授权访问、使用、披露和更改的风险。我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全，其中包括：（1）使用加密技术（例如TLS）、匿名化处理等来确保您的数据在传输过程中保持私密性；（2）提供多种安全功能来协助您保护自己的帐号安全；（3）审查我们在收集、存储和处理信息方面的做法（包括实体安全措施），以防未经授权的人员访问我们的系统；（4）所有因提供服务而必须接触个人信息的
            「电鸭」员工、承包商和代理商等，都需要遵守合同中规定的严格保密义务，否则可将被处分或被解约；（5）我们建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用，确保未收集与我们提供的服务无关的个人信息。
          </strong>
        </p>
        <p class="p3">
          <strong>
            3、您的账号均有安全保护功能，请妥善保管您的账号及密码信息。「电鸭App」将通过向其他服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您确认知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，为防止安全事故的发生，我们已按照法律法规的规定，制定了妥善的预警机制和应急预案。如确发生安全事件，我们将及时将相关情况选择以邮件、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况，紧密配合政府机关的工作。同时我们强烈建议您在使用产品和服务时充分注意对个人信息的保护，采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。我们也会提供多种安全功能来协助您保护自己的个人信息安全。
          </strong>
        </p>
        <p class="p3">
          <strong>
            4、我们严格限制访问信息的人员范围，要求他们遵守保密义务并进行审计，违反义务的人员会根据规定进行处罚。我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息。我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。
          </strong>
        </p>
        <p class="p3">
          <strong>5、您能做什么？</strong>
        </p>
        <p class="p1">
          您可以通过不向任何人（除非此人经您正式授权）披露您的登录密码或账号信息，您可以为「电鸭
          App」设置唯一的密码，以防止其他网站密码泄露危害您在「电鸭
          App」的账号安全。无论何时，请不要向任何人（包括自称是「电鸭
          App」客服的人士）透露您收到的验证码。无论您何时作为「电鸭
          App」账号用户登录「电鸭
          App」，尤其是在他人的计算机、手机或公共互联网终端上登录时，在使用结束时您总应注销登出。「电鸭
          App」不对因您未能保持个人信息的私密性而导致第三方访问您的个人信息进而造成的安全疏漏承担责任。尽管有上述规定，如果发生其他任何互联网用户未经授权使用您账号的情况或其他任何安全漏洞，您应当立即通知我们。您的协助将有助于我们保护您个人信息的私密性。
        </p>
        <p class="p2">
          <strong>五、我们如何处理未成年人提供的个人信息</strong>
        </p>
        <p class="p3">
          <strong>
            1、我们将不满 18
            周岁的任何人均视为未成年人，我们非常重视未成年人信息的保护。如您为未成年人，我们要求您请您的父母或监护人监护、指导下共同仔细阅读本隐私政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。
          </strong>
        </p>
        <p class="p3">
          <strong>
            2、对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为了保护未成年人而使用或披露有关未成年人的个人数据。
          </strong>
        </p>
        <p class="p3">
          <strong>
            3、我们认为监督孩子使用我们的产品或服务是家长或监护人的责任。我们不直接向儿童提供服务，也不将儿童的个人信息用于营销目的。若您是未成年人的家长或监护人，当您对您所监护的未成年人的个人信息有相关疑问时，或认为未成年人向「电鸭
            App」提交了个人信息，请通过本隐私政策第十一条中公示的联系方式与我们联系。
          </strong>
        </p>
        <p class="p2">
          <strong>六、我们如何共享、转让、公开披露您的个人信息</strong>
        </p>
        <p class="p3">
          <strong>1、共享</strong>
        </p>
        <p class="p1">
          我们不会将任何个人信息出售给第三方。我们有时可能会向第三方共享您的个人信息，以便提供或改进我们的产品或服务，包括根据您的要求提供产品或服务。如果您不再希望我们共享这些信息，请发送邮件至eleduck@qq.com与我们联系
        </p>
        <p class="p1">
          <strong>1.1 您主动选择的共享</strong>
        </p>
        <p class="p1">
          在获得您的明确同意或主动选择的情况下，与您指定的第三方共享您授权/请求范围内的信息。例如，您使用「电鸭
          App」账号快捷登录第三方网站或者APP。我们会提供社交网络服务，您在使用这一类型服务时，您所上传或发布的信息（包括您公开的个人信息、您的通讯录、好友圈）、您对他人上传或发布的信息作出的回应，以及与这些信息有关的日志信息等，只要您不删除这些信息，它们会一直留存在公共领域，并被使用我们服务的其他用户分享、浏览。即使您删除这些信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或第三方在公共领域保存。请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。您可以自行删除您上传、发布或分享的信息，如要求我们为您删除您的相关信息，请发送邮件到eleduck@qq.com
          与我们联络并提出您的要求，我们预计在收到后15个工作日内完成并核查和处理。
        </p>
        <p class="p1">
          <strong>1.2 与我们的关联公司共享信息</strong>
        </p>
        <p class="p1">
          为了顺利地从事商业经营，以向您提供产品或服务的全部功能，我们可能不时与其他的「电鸭
          App」关联公司共享您的个人信息。
        </p>
        <p class="p1">
          <strong>1.3 其他</strong>
        </p>
        <p class="p1">
          根据法律法规规定要求、法律程序、诉讼和/或公共机构和政府部门依法提出的要求，「电鸭App」可能有必要披露您的个人信息。如果我们确定就国家安全、执法或具有公众重要性的其他事宜而言，披露是必须的或适当的，我们也可能会披露关于您的信息。如果我们确定为了执行我们的条款或保护我们的经营、权利、资产或产品，或保护用户，或对于达成以下目的（检测、预防并解决欺诈、对产品的未授权使用、对我们条款或政策的违反或其他有害或非法活动）披露是合理必要的，我们也可能会披露关于您的信息。（为避免疑问，在当地数据保护法律明确许可的范围内且仅限在此情况下，「电鸭App」才会在未经您同意的情况下收集、使用或披露您的个人信息。）这可能包括向公共或政府机构提供信息；与第三方合作伙伴交流有关您账户可靠性方面的信息，以防止在我们产品内外所进行的欺诈、违规等其他有害行为。
        </p>
        <p class="p1">
          <strong>1.4 此外，我们可能与下列人员共享您的个人信息：</strong>
        </p>
        <p class="p1">
          ●
          我们的会计师、审计师、律师或类似的顾问，当我们要求他们提供专业建议时；以及●
          投资者以及其他相关第三方，如果发生实际或潜在的出售或其他公司交易，且与「电鸭App」实体相关时；以及●
          其他任何第三方，如经您授权就特定信息进行披露共享。
        </p>
        <p class="p3">
          <strong>2、转让</strong>
        </p>
        <p class="p1">
          除以下情形外，「电鸭App」不会将您的信息转让给任何主体：●
          获得您的明确同意；●
          如果「电鸭App」参与兼并、收购或出售其资产的全部或部分，我们将通过电子邮件和/或在我们网站上发布醒目通知，告知对您个人信息所有权、使用方面的任何变化，以及您可能拥有的关于您个人信息的任何选择。
        </p>
        <p class="p3">
          <strong>3、公开披露</strong>
        </p>
        <p class="p1">
          「电鸭App」仅会在以下情况下，公开披露您的个人信息：●
          获得您的明确同意；●
          基于法律或合理依据的公开披露：包括法律法规规范、法律程序、诉讼或应政府主管部门要求。
        </p>
        <p class="p2">
          <strong>七、信息的存储</strong>
        </p>
        <p class="p3">
          <strong>1、信息存储的地点</strong>
        </p>
        <p class="p1">
          我们将从中华人民共和国境内获得的信息存放于中华人民共和国境内。如果发生数据的跨境传输，我们会单独向您以站内信或邮件的方式告知您数据出境的目的、接收方，并征得您的授权同意，我们会严格遵守中国的法律法规规定，确保数据接收方有充足的数据保护能力来保护您的个人信息。
        </p>
        <p class="p3">
          <strong>2、信息存储的期限</strong>
        </p>
        <p class="p1">
          我们承诺始终按照法律的规定在合理必要期限内存储您个人信息。超出上述期限后，我们将删除您的个人信息。当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息。
        </p>
        <p class="p2">
          <strong>八、第三方服务提供商</strong>
        </p>
        <p class="p3">
          <strong>
            1、为方便您的访问并丰富您的体验，可能会有第三方提供的产品或服务。您可以选择是否访问这类内容或链接，或是否使用该第三方的产品或服务。但我们对于第三方提供的产品或服务没有控制权。我们无法控制第三方掌握的您的任何个人信息。您在使用第三方产品或服务过程中的信息保护问题，不适用于本政策的管理。本政策也不适用于您自行选择提供给第三方的任何信息。请您查看该第三方的隐私保护政策。
          </strong>
        </p>
        <p class="p3">相关第三方服务及隐私政策如下：</p>
        <p class="p3">
          SDK名称：微信开放平台(登录与分享SDK)
          <br />
          具体功能：帮助用户登录微信，并使用微信分享功能
          <br />
          获取信息：设备信息、Wi-Fi地址、MAC地址
          <br />
          第三方机构名称：深圳市腾讯计算机系统有限公司
          <br />
          第三方相关隐私政策：https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy
        </p>
        <p class="p3">
          SDK名称：腾讯QQ分享SDK
          <br />
          具体功能：分享
          <br />
          获取信息：设备信息、Wi-Fi地址、MAC地址
          <br />
          第三方机构名称：深圳市腾讯计算机系统有限公司
          <br />
          第三方相关隐私政策：https://wiki.connect.qq.com/QQ互联SDK隐私保护声明
        </p>
        <p class="p3">
          SDK名称：新浪微博分享SDK
          <br />
          具体功能：分享
          <br />
          获取信息：设备信息、Wi-Fi地址、MAC地址
          <br />
          第三方机构名称：北京微梦创科网络技术有限公司
          <br />
          第三方相关隐私政策：https://weibo.com/signup/v5/privacy?spm=a1zaa.8161610.0.0.4f8776217Wu8R1
        </p>
        <p class="p3">
          SDK名称：Bugly
          <br />
          具体功能：帮助开发人员定位用户使用App过程中的闪退问题
          <br />
          获取信息：设备信息
          <br />
          第三方机构名称：深圳市腾讯计算机系统有限公司
          <br />
          第三方相关隐私政策：https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf
        </p>
        <p class="p3">
          SDK名称：极光推送
          <br/>
          第三方主体：深圳市和讯华谷信息技术有限公司
          <br/>
          SDK 用途：为 APP 用户提供信息推送服务
          <br/>
          收集个人信息类型：
          <br/>
          设备参数及系统信息(设备类型、设备型号、系统版本、及相关硬件信息)：用于识别用户的设备类型、设备型号、系统版本等，确保消息准确下发；
          <br/>
          设备标识符（IMEI、IDFA、Android ID、GAID、 MAC、OAID、VAID、AAID、IMSI、MEID、UAID、硬件序列号信息、ICCID、SIM信息）：用于识别唯一用户，保证推送的精准送达及推送信息的准确统计；
          <br/>
          网络信息(IP 地址、WiFi 信息、基站信息、DNS地址、DHCP地址、SSID、BSSID)与位置信息（经纬度）：用于优化SDK与极光服务器的网络连接请求，保证服务的稳定性和连续性，同时实现区域推送功能；
          <br/>
          应用列表信息(应用崩溃信息、通知开关状态、APP 应用列表及活跃状态、APP 应用页面信息、APP 功能事件相关信息)：当一个设备有多个 APP 的推送链路同时活跃时，我们采用合并链路技术，随机合并成一条链路，以达到为用户节省电省流量的目的。
          <br/>
          数据处理方式：通过去标识化、加密传输及其他安全方式
          <br/>
          官网链接：https://www.jiguang.cn/push
          <br/>
          隐私政策链接：https://www.jiguang.cn/license/privacy
          <ul>
            <li>自启动和关联启动说明
              <ol>
                <li>
                为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。
                </li>
                <li>当您打开「电鸭App」内容类推送消息，在征得您的明确同意后，会跳转「电鸭App」打开相关内容。在未征得您同意的情况下，则不会有关联启动。</li>
                <li>当您打开「电鸭App」内部下载的文件后，会关联启动第三方APP</li>
              </ol>
            </li>
          </ul>
        </p>
        <p class="p3">
          SDK名称：OPPO推送
          <br/>
          涉及的个人信息类型：设备标识符（如 IMEI、ICCID、IMSI、Android ID、GAID）、应用信息（如应用包名、版本号和运行状态）、网络信息（如 IP 或域名连接结果，当前网络类型）
          <br/>
          使用目的：推送消息
          <br/>
          使用场景：在 OPPO 手机终端推送消息时使用
          <br/>
          第三方主体：广东欢太科技有限公司
          <br/>
          数据处理方式：通过加密传输和处理的安全处理方式
          <br/>
          官网链接：https://open.oppomobile.com/new/introduction?page_name=oppopush
          <br/>
          隐私政策：https://open.oppomobile.com/wiki/doc#id=10288
        </p>
        <p class="p3">
          SDK名称：vivo推送
          <br/>
          涉及的个人信息类型：设备信息
          <br/>
          使用目的：推送消息
          <br/>
          使用场景：在 vivo 手机终端推送消息时使用
          <br/>
          第三方主体：广东天宸网络科技有限公司及将来受让运营 vivo 开放平台的公司
          <br/>
          数据处理方式：通过去标识化、加密传输及其他安全方式
          <br/>
          官网链接：https://dev.vivo.com.cn/promote/pushNews
          <br/>
          隐私政策：https://www.vivo.com.cn/about-vivo/privacy-policy
        </p>
        <p class="p3">
          SDK名称：华为推送
          <br/>
          涉及的个人信息类型：应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息和系统设置信息
          <br/>
          使用目的：推送消息
          <br/>
          使用场景：在华为手机终端推送消息时使用
          <br/>
          第三方主体：华为软件技术有限公司
          <br/>
          数据处理方式：通过去标识化、加密传输及其他安全方式
          <br/>
          官网链接：https://developer.huawei.com/consumer/cn/
          <br/>
          隐私政策：https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177
        </p>
        <p class="p2">
          <strong>九、本政策的更新</strong>
        </p>
        <p class="p3">
          <strong>
            1、我们可能会不定期修改、更新本隐私政策，有关隐私政策的更新，我们会在
            「电鸭App」 中以通知公告等形式发布，您可以访问 「电鸭App」
            查询最新版本的隐私政策。对于重大变更，我们会向您发出郑重通知（包括对于某些服务，我们会通过电子邮件发送通知，说明对隐私政策进行的更改）。
          </strong>
        </p>
        <p class="p2">
          <strong>十、适用范围</strong>
        </p>
        <p class="p3">
          <strong>
            1、我们的隐私政策适用于由西安总而言之网络科技有限公司及其关联公司提供的所有服务，包括
            「电鸭App」及所提供的服务，但是不包括附有独立隐私政策的服务（如第三方提供的产品和服务）。
          </strong>
        </p>
        <p class="p3">
          <strong>
            2、我们的隐私权政策不适用于第三方提供的产品和服务，例如在
            「电鸭App」及
            eleduck.com上由第三方提供的产品和服务，以及在我们的服务中链接到的其他网站，这些产品、服务或网站会有独立的隐私政策予以规范，请另行查阅相应的政策规定。
          </strong>
        </p>
        <p class="p2">
          <strong>十一、如何联系我们</strong>
        </p>
        <p class="p1">
          您可通过以下方式与我们联系：1、如对本政策内容有任何疑问、意见或建议，您可通过
          「电鸭App」意见与反馈功能与我们联系；2、如果发现个人信息可能被泄露，您可以通过「电鸭App」意见与反馈功能投诉，我们将在15个工作日内联络您并完成核查和处理；3、我们还设立了意见、建议反馈邮箱，您可以通过eleduck@qq.com与我们联系，我们预计在15个工作日内联络您并完成核查和处理。
        </p>
      </Card>
    </SiteLayout>
  );
};
